import React, { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import ApiKeyPage from "./pages/ApiKeyPage";
import AppShell from "./components/layout/AppShell";
import JsonTemplatesPage from "./pages/JsonTemplatesPage";
import NewExtractionPage from "./pages/NewExtractionPage";
import ResultsPage from "./pages/ResultsPage";
import { djangoApi } from "./services/djangoApi";

const API_KEY_STORAGE = "ocrApiKey";

function App() {
  const [apiKey, setApiKey] = useState(() => {
    if (typeof window === "undefined") return "";
    return window.localStorage.getItem(API_KEY_STORAGE) || "";
  });
  const [clientInfo, setClientInfo] = useState(null);

  useEffect(() => {
    if (!apiKey || clientInfo) return;
    let isMounted = true;

    async function loadClientInfo() {
      try {
        const data = await djangoApi.validateApiKey(apiKey);
        if (!isMounted) return;
        setClientInfo(data);
      } catch {
        if (!isMounted) return;
        setApiKey("");
        setClientInfo(null);
        if (typeof window !== "undefined") {
          window.localStorage.removeItem(API_KEY_STORAGE);
        }
      }
    }

    loadClientInfo();
    return () => {
      isMounted = false;
    };
  }, [apiKey, clientInfo]);

  if (!apiKey) {
    return (
      <ApiKeyPage
        onValidated={({ apiKey: key, clientInfo: info }) => {
          setApiKey(key);
          setClientInfo(info);
          if (typeof window !== "undefined") {
            window.localStorage.setItem(API_KEY_STORAGE, key);
          }
        }}
      />
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<AppShell apiKey={apiKey} clientInfo={clientInfo} />}
        >
          <Route index element={<Navigate to="/newextraction" replace />} />
          <Route
            path="newextraction"
            element={<NewExtractionPage apiKey={apiKey} />}
          />
          <Route path="results" element={<ResultsPage apiKey={apiKey} />} />
          <Route
            path="json-templates"
            element={<JsonTemplatesPage apiKey={apiKey} />}
          />
        </Route>
        <Route path="*" element={<Navigate to="/newextraction" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
